"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIStepIndicator = _interopRequireDefault(require("UIComponents/connectedStep/UIStepIndicator"));

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _default = _react.default.createClass({
  displayName: "DynoPreviewCarouselSteps",
  propTypes: {
    activeStep: _react.default.PropTypes.number.isRequired,
    changeGDRPStep: _react.default.PropTypes.func,
    changeStep: _react.default.PropTypes.func,
    gdprStep: _react.default.PropTypes.number,
    isFormWithGDPR: _react.default.PropTypes.bool,
    mailCount: _react.default.PropTypes.number,
    hasForm: _react.default.PropTypes.bool
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowEditorPreview.leadFlowEditorCarouselSteps." + suffix;
  },
  getStepNames: function getStepNames() {
    var _this$props = this.props,
        mailCount = _this$props.mailCount,
        hasForm = _this$props.hasForm;
    var stepNames = [_I18n.default.text(this.langKey('calloutPreviewStepIndicator'))].concat((0, _toConsumableArray2.default)(hasForm ? [_I18n.default.text(this.langKey('formPreviewStepIndicator')), _I18n.default.text(this.langKey('thankYouPreviewStepIndicator'))] : []));

    if (hasForm) {
      for (var i = 0; i < mailCount; i++) {
        stepNames.push(_I18n.default.text(this.langKey('emailPreviewStepIndicator')) + " " + (i + 1));
      }
    }

    return stepNames;
  },
  getGDPRStepNames: function getGDPRStepNames() {
    return [_I18n.default.text('leadFlowEditor.leadFlowEditorPreview.GDPRCarouselSteps.form'), _I18n.default.text('leadFlowEditor.leadFlowEditorPreview.GDPRCarouselSteps.consent')];
  },
  handleStepClick: function handleStepClick(index) {
    var states = Object.keys(_DynoEditor.PREVIEW_DYNO_STATES || {});
    this.props.changeStep(states[index]);
  },
  renderGDPRCarousel: function renderGDPRCarousel() {
    return _react.default.createElement(_UIStepIndicator.default, {
      stepNames: this.getGDPRStepNames(),
      stepIndex: this.props.gdprStep,
      onStepClick: this.props.changeGDRPStep,
      responsiveBreakpoint: 300
    });
  },
  renderStepsIndicator: function renderStepsIndicator() {
    var _this$props2 = this.props,
        activeStep = _this$props2.activeStep,
        changeStep = _this$props2.changeStep;
    var stepNames = this.getStepNames();
    var handleClick = changeStep ? this.handleStepClick : null;
    return _react.default.createElement(_UIStepIndicator.default, {
      stepNames: stepNames,
      stepIndex: activeStep,
      onStepClick: handleClick
    });
  },
  render: function render() {
    var isFormWithGDPR = this.props.isFormWithGDPR;
    var content = isFormWithGDPR ? this.renderGDPRCarousel() : this.renderStepsIndicator();
    var gdprClass = isFormWithGDPR ? 'with-gdpr' : '';
    return _react.default.createElement(_UIGrid.default, {
      className: "dyno-preview-carousel-steps " + gdprClass
    }, content);
  }
});

exports.default = _default;
module.exports = exports.default;